import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, ListGroup, InputGroup, FormControl } from "react-bootstrap";
import { FiSearch, FiCheckCircle, FiCircle, FiBriefcase } from "react-icons/fi";
import { GlobalContext } from "../../Utils/GlobalContext";

const LoginSelecaoEntidade = ({ show, entidades, handleSelect, onCancel, autoSelect = true }) => {
  const [selectedEntidade, setSelectedEntidade] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEntidades, setFilteredEntidades] = useState([]);
  const { setGlobalData } = useContext(GlobalContext);

  // Apenas entidades ativas podem ser selecionadas
  const ativas = entidades.filter((e) => !e.situacao || e.situacao === "A");

  useEffect(() => {
    if (!show) return;

    if (autoSelect && ativas.length === 1) {
      handleSelect(ativas[0].id);
      setGlobalData((prevData) => ({
        ...prevData,
        entidade_id: String(ativas[0].id),
      }));
    } else if (ativas.length > 0) {
      setSelectedEntidade(ativas[0]);
    }

    setFilteredEntidades(ativas);
  }, [show, entidades, handleSelect, setGlobalData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredEntidades(ativas);
      return;
    }
    const term = searchTerm.toLowerCase();
    setFilteredEntidades(ativas.filter((e) => e.nome.toLowerCase().includes(term)));
  }, [searchTerm, entidades]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleEntidadeSelect = (entidade) => {
    setSelectedEntidade(entidade);
  };

  const handleConfirm = () => {
    if (selectedEntidade) {
      setGlobalData((prevData) => ({
        ...prevData,
        entidade_id: String(selectedEntidade.id),
      }));
      handleSelect(selectedEntidade.id);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    // Fluxo de login: cancelar = deslogar
    localStorage.removeItem("authToken");
    window.location.reload();
  };

  return (
    <Modal
      show={show && ativas.length > 1}
      onHide={() => {}}
      backdrop="static"
      className="entidade-selection-modal"
      dialogClassName="modal-dialog-top"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <FiBriefcase className="me-2" size={24} />
          Selecione sua Entidade
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="pt-4">
        {ativas.length > 3 && (
          <InputGroup className="mb-3">
            <InputGroup.Text>
              <FiSearch />
            </InputGroup.Text>
            <FormControl
              placeholder="Buscar entidade..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        )}
        
        <div className="entidade-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <ListGroup>
            {filteredEntidades.length > 0 ? (
              filteredEntidades.map((entidade) => (
                <ListGroup.Item
                  key={entidade.id}
                  action
                  active={selectedEntidade?.id === entidade.id}
                  onClick={() => handleEntidadeSelect(entidade)}
                  className="d-flex align-items-center border-0 rounded mb-2"
                  style={{ 
                    backgroundColor: selectedEntidade?.id === entidade.id ? '#e7f5ff' : '#f8f9fa',
                    color: 'inherit'
                  }}
                >
                  <div className="me-3">
                    {selectedEntidade?.id === entidade.id ? (
                      <FiCheckCircle size={20} color="#0d6efd" />
                    ) : (
                      <FiCircle size={20} className="text-muted" />
                    )}
                  </div>
                  <div>
                    <h6 className="mb-0">{entidade.nome}</h6>
                    {entidade.descricao && (
                      <small className="text-muted">{entidade.descricao}</small>
                    )}
                  </div>
                </ListGroup.Item>
              ))
            ) : (
              <p className="text-center text-muted">
                Nenhuma entidade encontrada com esse termo.
              </p>
            )}
          </ListGroup>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Button variant="light" className="modal-footer-btn-cancelar" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            variant="success"
            className="modal-footer-btn-salvar"
            onClick={handleConfirm}
            disabled={!selectedEntidade}
          >
            Continuar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginSelecaoEntidade;